import { createContext, Dispatch, SetStateAction } from "react";

const Contexts = createContext<{
  breadItem: { path: string; name: string }[];
  setBreadItem: Dispatch<SetStateAction<{ path: string; name: string }[]>>;
}>({ breadItem: [], setBreadItem: () => {} });

export default Contexts;
